import { RoutePaths } from '@interfaces/routePaths'
import {
  Anchor,
  Box,
  Button,
  Checkbox,
  Flex,
  Group,
  Select,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import { randomBool } from '@utils/randomBool'

export interface PrivacySettingsProps {
  route: RoutePaths
}

export const PrivacySettings = (props: PrivacySettingsProps) => {
  const { route } = props

  return (
    <>
      <Box maw={600} p="md">
        <Stack align="center">
          <Text size="lg" ta="center">
            What, if any, personal data of yours do you want to make visible in
            your employer's location profile{' '}
            {route !== RoutePaths.ACCOUNT_SETTINGS_PRIVACY_COMMUNITY_PARTNERS
              ? 'to people who are'
              : 'the staff at'}{' '}
            {route ===
              RoutePaths.ACCOUNT_SETTINGS_PRIVACY_PROSPECTIVE_CONTACTS &&
              'considering'}
            {route === RoutePaths.ACCOUNT_SETTINGS_PRIVACY_CONTACTS &&
              'currently sharing'}
            {route === RoutePaths.ACCOUNT_SETTINGS_PRIVACY_COMMUNITY_PARTNERS &&
              'community partners'}{' '}
            sharing their personal information with your employer?
          </Text>
          <Text ta="center" fs="italic">
            <Text c="red" span>
              *
            </Text>{' '}
            empty fields can't be shared.
          </Text>
          <Box w={200}>
            <Button size="compact-md">View location profile</Button>
          </Box>
        </Stack>

        <Flex mt="xl">
          <Box w={290}>
            <Group align="center">
              <Title order={4}>Profile</Title>
              <Anchor size="lg">Turn Off All</Anchor>
            </Group>
            <Stack mt="md" gap="xs">
              <Checkbox size="md" label="Prefix" disabled />
              <Checkbox
                checked={randomBool()}
                size="md"
                label="Full first name"
              />
              <Checkbox
                checked={randomBool()}
                size="md"
                label="Full last name"
              />
              <Checkbox
                checked={randomBool()}
                size="md"
                label="First letter of first name"
              />
              <Checkbox
                checked={randomBool()}
                size="md"
                label="First letter of last name"
              />
              <Checkbox checked={randomBool()} size="md" label="Photo" />
              <Checkbox checked={randomBool()} size="md" label="Languages" />
              <Checkbox
                checked={randomBool()}
                size="md"
                label="Birth month and day"
              />
              <Checkbox checked={randomBool()} size="md" label="Birth year" />
              <Checkbox checked={randomBool()} size="md" label="Gender" />
              <Checkbox checked={randomBool()} size="md" label="Job title" />
            </Stack>
          </Box>
          <Box w={290}>
            <Group align="center">
              <Title order={4}>Contact info</Title>
              <Anchor size="lg">Turn On All</Anchor>
            </Group>
            <Stack mt="md" gap="xs">
              <Checkbox checked={randomBool()} size="md" label="Work email" />
              <Checkbox
                checked={randomBool()}
                size="md"
                label="Direct work phone"
              />
              <Checkbox checked={randomBool()} size="md" label="Mobile phone" />
              <Text c="dimmed" size="sm">
                The main office phone number is shown if you elect to display
                any of your info.
              </Text>
            </Stack>
            <Title order={4} mt="xl">
              Identify me as a point of contact for these services:{' '}
              <Text size="sm" c="dimmed">
                (optional)
              </Text>
            </Title>
            <Select
              size="md"
              mt="md"
              label="Services"
              data={[]}
              placeholder="Select one or more"
            />
          </Box>
        </Flex>
      </Box>
      <Flex maw={580} mt="lg" justify="flex-end" gap="xs">
        <Button size="md" variant="default">
          Discard Changes
        </Button>
        <Button size="md">Save</Button>
      </Flex>
    </>
  )
}
